export default __webpack_public_path__ + "static/media/apple_help_3.9cf0b6ba.jpg";